import React from 'react';
import { TagGroup as PloneTagGroup, Tag } from '@plone/components';
import { clsx } from 'clsx';
import './TagGroup.scss';

export interface ESSTagGroupProps {
  variant?: 'default' | 'outline' | 'solid';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  children?: React.ReactNode;
  [key: string]: any; // Allow any props from @plone/components TagGroup
}

/**
 * ESS TagGroup Component
 *
 * A component for displaying a group of tags/labels.
 * Wraps @plone/components TagGroup with ESS design system styling.
 *
 * @example
 * ```tsx
 * import { ESSTagGroup, Tag } from './components/Atoms/TagGroup';
 *
 * <ESSTagGroup variant="solid" size="md">
 *   <Tag>React</Tag>
 *   <Tag>TypeScript</Tag>
 *   <Tag>Volto</Tag>
 * </ESSTagGroup>
 * ```
 */
export const ESSTagGroup: React.FC<ESSTagGroupProps> = ({
  variant = 'default',
  size = 'md',
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={clsx(
        'ess-taggroup',
        `ess-taggroup--${variant}`,
        `ess-taggroup--${size}`,
        className,
      )}
    >
      <PloneTagGroup {...props}>{children}</PloneTagGroup>
    </div>
  );
};

// Re-export Tag for convenience
export { Tag };

export default ESSTagGroup;
